import { Vue, Component, Prop } from 'vue-property-decorator';
import GenerateNewPopUpComponent from '@/components/my-gooru-pages/generate-new-access-code/generate-new-access-code';
import { myGooruAPI } from '@/providers/apis/my-gooru/my-gooru';
@Component({
    name: 'access-code-page',
    components: {
        GenerateNewPopUpComponent,
    },
})

export default class AccessCodePageComponent extends Vue {

    // Properties

    private customClassSettingHead: any = [
        {
            label: 'Tenant Name',
            key: 'customer_name',
            sortable: false,
            tdClass: 'vertically-center',
        },
        {
            label: 'Created on',
            key: 'start_at',
            sortable: false,
            tdClass: 'vertically-center',
        },
        {
            label: 'Expiry Date',
            key: 'expires_at',
            sortable: false,
            tdClass: 'vertically-center',
        },
        {
            label: 'Interests',
            key: 'getInterestName',
            sortable: false,
            tdClass: 'vertically-center action-col',
        },
        {
            label: 'Access Code',
            key: 'access_code',
            sortable: false,
            tdClass: 'vertically-center action-col',
        },
        {
            label: '',
            key: 'cpoytext',
            sortable: false,
            tdClass: 'vertically-center action-col',
        },

    ];

    private getInterestName: any = [];
    private interestListData: any = [];
    private interestGetData: any = [];
    private mygroouAccessList: any = [];
    private searchAccessList: string = '';
    private searchTerms: string = '';
    private getListIndex: string = '';
    private offset: number = 0;
    private limit: number = 10;
    private perPage: number = 10;
    private totalRowCounts: number = 10;
    private currentPage: number = 1;

    private isLoading: boolean = false;
    private isCopied: boolean = false;
    private onEditAcessData: boolean = false;
    private getEditIndexList: any = {};

    public generateNewAccessCode() {
        this.onEditAcessData = false;
        this.$bvModal.show('generate-new-acces-code');
    }
    public closePopUp() {
        this.$bvModal.hide('generate-new-acces-code');
    }
    public onSelectPage(pageNumber: number) {
        window.scrollTo(0, 0);
        this.currentPage = pageNumber;
        this.currentPage = pageNumber;
        this.offset = (pageNumber - 1) * this.limit;
        this.mygooruAccessList();
    }


    // Methods


    public copyToClipboard(code: any, data: any, index: any) {
        this.getListIndex = data.index;
        navigator.clipboard.writeText(code);
        if (data.item.access_code === code) {
            this.isCopied = true;
            setTimeout(() => {
                this.isCopied = false;
            }, 1000);
        }
    }

    public onEditAccessList(data: any) {
        this.onEditAcessData = true;
        this.getEditIndexList = data.item;
        this.$bvModal.show('generate-new-acces-code');
    }

    public searchAcessList() {
        this.offset = 0;
        if (this.searchAccessList.length > 2) {
            this.mygooruAccessList();
        }
    }

    // Hooks

    private created() {
        this.getInterestList();
        setTimeout(() => {
            this.mygooruAccessList();
        }, 2000);
    }
    private searchAccessListClear() {
        this.searchAccessList = '';
        this.offset = 0;
        this.mygooruAccessList();

    }
    private mygooruAccessList() {
        this.isLoading = true;
        const offset = this.offset;
        const limit = this.limit;
        const searchText = this.searchAccessList;
        const params: any = {
            offset,
            limit,
            searchText,
        };

        myGooruAPI.getMygooruAccessList(params).then((response: any) => {
            this.isLoading = false;
            const dataAcceslist = response.data.contents;
            this.totalRowCounts = response.data.totalCount;
            this.interestGetData = [];
            this.getInterestName = [];
            for (const element of this.interestListData) {
                for (const elementSecond of element.interest) {
                    this.interestGetData.push(elementSecond);
                }
            }
            this.mygroouAccessList = [];
            for (const data of dataAcceslist) {
                const getSettingsIndex = data.settings ? data.settings.interest : '';
                this.getInterestName = [];
                const getSelectedinterestId = this.interestGetData.filter(
                    (person: any) => getSettingsIndex.includes(person.id),
                );
                data.getInterestName = getSelectedinterestId;
                this.mygroouAccessList.push(data);
            }

        });

    }

    private getInterestList() {
        this.isLoading = true;
        myGooruAPI.getLearnerInterest().then((response: any) => {
            this.interestListData = response.data.category[0].sub_category;
        });
    }


}


